import { fallback } from '@sdk/helpers/misc/nullable';

function labelize(option) {
  return typeof option === 'string' ? option : option.label;
}

export function prepare(label) {
  return String(labelize(label)).toLowerCase()
    .replace(/[àáâãäå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ç]/g, 'c');
}

export function alphabetical(first, second) {
  return prepare(first).localeCompare(prepare(second));
}

export function dummy(value) {
  return value;
}

export default function options(list = [], config = {}) {
  const custom = {
    ...config,

    label: fallback(config.label, 'name'),
    value: fallback(config.value, 'id'),
    key: fallback(config.key, 'id'),

    sort: fallback(config.sort, alphabetical),
    prettify: fallback(config.prettify, dummy),
    manipulate: fallback(config.manipulate, dummy),
  };

  function translate(item) {
    return {
      label: custom.prettify(item[custom.label]),
      value: custom.manipulate(item[custom.value]),
      key: item[custom.key],
      disabled: item.disabled,
    };
  }

  return Object.values(list).map(translate).sort(custom.sort);
}
